export default __webpack_public_path__ + "static/points-4636a014397da2c5c27e5b2dacb084f6.jpg";